// extracted by mini-css-extract-plugin
module.exports = {"productDisclaimer":"ProductDisclaimer_productDisclaimer__oiLxm","productDisclaimerText":"ProductDisclaimer_productDisclaimerText__fQcPC"};